import { useState } from 'react';
import CoachOnboardingPasswordBlock from '../../components/CoachOnboarding/CoachOnboardingPasswordBlock';
import CoachOnboardingSuccessBlock from '../../components/CoachOnboarding/CoachOnboardingSuccessBlock';
import AuthPagesLayout from '../../components/Layout/AuthPagesLayout';

function CoachOnboarding() {
  const [currentBlock, setCurrentBlock] = useState<'password' | 'success'>('password');

  return (
    <AuthPagesLayout>
      {currentBlock === 'password' && (
        <CoachOnboardingPasswordBlock onSuccess={() => setCurrentBlock('success')} />
      )}
      {currentBlock === 'success' && <CoachOnboardingSuccessBlock />}
    </AuthPagesLayout>
  );
}

export default CoachOnboarding;
